import { Reducer } from 'redux';

import { IRootAction } from './IRootAction';
export const chainReducers =
  <State>(initialState: State, ...reducers: Reducer<State>[]): Reducer<State> =>
  (state: State = initialState, action: IRootAction) =>
    reducers.reduce((previousState, reducer) => reducer(previousState, action), state);
